import LazyLoad from "vanilla-lazyload";
import Lenis from "lenis";

export const onLoading = () => {
  addClassesToHTML();
  addTargetBlank();
  addVHandVWValues();

  // addFigmaGrid();

  addLazyLoad();
  addLenis();
  addToggleNewsletterForm();
  addToggleLegalPopup();
};

const addClassesToHTML = () => {
  const isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iP(ad|hone)/i);
  const webkit = !!ua.match(/WebKit/i);
  const isiOS = iOS && webkit && !ua.match(/CriOS/i);
  const touch = isTouch ? "touch" : "no-touch";
  const os = isiOS ? "ios" : "no-ios";
  document.documentElement.classList.remove(
    "touch",
    "no-touch",
    "ios",
    "no-ios"
  );
  document.documentElement.classList.add(touch, os);
};

const addTargetBlank = () => {
  const links = document.querySelectorAll("a");
  links.forEach((link) => {
    if (link.target) {
      return;
    } else if (link.host !== window.location.host) {
      link.target = "_blank";
      link.rel = "noopener";
    } else {
      link.target = "_self";
    }
  });
};

const addVHandVWValues = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  const vw = window.innerWidth * 0.01;
  document.documentElement.style.setProperty("--vw", `${vw}px`);

  window.addEventListener("resize", () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    const vw = window.innerWidth * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  });
};

function addFigmaGrid() {
  let gridVisible = false;

  const isFigma = document.querySelector(".figma-grid");
  if (isFigma) {
    return; // Figma grid already exists
  }

  const gridContainer = document.createElement("div");
  gridContainer.style.display = "none";

  gridContainer.classList.add("figma-grid");

  const createGrid = () => {
    const isMobile = window.innerWidth < 768; // Adjust breakpoint as needed
    const columns = isMobile ? 1 : 3;
    const columnWidth = 100 / columns;

    gridContainer.innerHTML = ""; // Clear existing grid

    for (let i = 0; i < columns; i++) {
      const column = document.createElement("div");
      column.classList.add("figma-grid-column");
      column.style.width = `${columnWidth}%`;
      gridContainer.appendChild(column);
    }
  };

  createGrid();
  window.addEventListener("resize", createGrid);

  document.body.appendChild(gridContainer);

  // Press g to toggle the grid
  window.addEventListener("keydown", (e) => {
    if (e.key === "g") {
      gridVisible = !gridVisible;
      gridContainer.style.display = gridVisible ? "flex" : "none";
    }
  });
}

const addLazyLoad = () => {
  var lazyLoadInstance = new LazyLoad();
};

const addLenis = () => {
  const lenis = new Lenis();

  // Listen for the scroll event and update header visibility using Lenis
  lenis.on("scroll", (e) => {
    addVideoParallax(e);
    updateHeaderVisibleWhileTop(lenis);
  });

  // Use requestAnimationFrame to continuously update the scroll
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
};

const addVideoParallax = (lenis) => {
  const video = document.querySelector("video");
  if (!video) return;

  const y = lenis.animatedScroll;
  video.style.transform = `translate(0px, ${y}px)`;
};

// Update header visibility using Lenis scroll position
const updateHeaderVisibleWhileTop = (lenis) => {
  const header = document.querySelector("header");
  if (!header) return;
  // Use Lenis scroll value if available, fallback to window.scrollY
  const isTop =
    (lenis.scroll !== undefined ? lenis.scroll : window.scrollY) <= 64;
  if (isTop) {
    header.classList.remove("no-visible");
  } else {
    header.classList.add("no-visible");
  }
};

const addToggleNewsletterForm = () => {
  const form = document.querySelector(".klaviyo-form-UHGQNJ");
  if (!form) return;

  form.classList.add("hidden");

  const newsletterButton = document.querySelector(".newsletter");
  if (!newsletterButton) return;

  const instagram = document.querySelector(".instagram");
  const whatsapp = document.querySelector(".whatsapp");
  const paragraph = document.querySelector(".content_container .paragraph");

  newsletterButton.addEventListener("click", () => {
    form.classList.toggle("hidden");
    if (instagram) {
      instagram.classList.toggle("hidden");
    }
    if (whatsapp) {
      whatsapp.classList.toggle("hidden");
    }
    if (paragraph) {
      paragraph.classList.toggle("hidden");
    }
  });
};

const addToggleLegalPopup = () => {
  const btn = document.querySelector(".legal_infos");
  if (!btn) return;

  const legalPopup = document.querySelector(".legal_popup");
  if (!legalPopup) return;

  const closeButton = legalPopup.querySelector(".close_popup");
  if (!closeButton) return;

  btn.addEventListener("click", (e) => {
    e.preventDefault();
    legalPopup.classList.toggle("show");
    console.log("Legal popup toggled");
  });

  closeButton.addEventListener("click", () => {
    legalPopup.classList.remove("show");
  });

  // press esc to close the popup
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      legalPopup.classList.remove("show");
    }
  });
};
